
// src/api/api.js
import axios from "axios";
import {
  getAccessToken,
  getRefreshToken,
  setAccessToken,
  setRefreshToken,
  clearTokens,
} from "@/utils/tokenCookies";

export const BASE_URL_DOMAIN = import.meta.env.VITE_API_URL;
const API_BASE_URL = BASE_URL_DOMAIN;

// Asosiy klient (har doim Authorization yuboradi)
const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: false,
});


// Refresh uchun alohida klient (Authorization yubormaydi)
const refreshClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: false,
});

// ----- Request interceptor: access token qo'shish
api.interceptors.request.use(
  (config) => {
    const token = getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      delete config.headers.Authorization;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ----- 401'larni boshqarish: bir martalik refresh + navbat
let isRefreshing = false;
let pendingQueue = []; // { resolve, reject, config }

// Refresh funksiyasi (bevosita chaqirish kerak bo'lsa ham foydali)
export async function refreshTokens() {
  const rt = getRefreshToken();
  if (!rt) throw new Error("No refresh token");

  const { data } = await refreshClient.post("/oauth/refresh", {
    token: rt, // <— skrinshotdagi body nomi
  });

  // Backend javobi: { access_token, refresh_token }
  if (data?.access_token) setAccessToken(data.access_token);
  if (data?.refresh_token) setRefreshToken(data.refresh_token);

  return data;
}

// ----- Response interceptor
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;

    // Agar 401 va birinchi marta urinish bo'lsa — refresh qilib ko'ramiz
    const isAuthError =
      error?.response?.status === 401 ||
      error?.response?.status === 403; // ba’zi bekendlarda 403 qaytadi

    // refresh endpointning o'zi 401 bo'lsa, cheksiz loop bo'lmasin
    const isRefreshCall = original?.url?.includes("/apis/oauth/refresh");

    if (isAuthError && !isRefreshCall && !original._retry) {
      original._retry = true;

      // Bir vaqtning o'zida faqat bitta refresh ishlasin
      if (isRefreshing) {
        // navbatga qo'shamiz — refresh tugagach qayta yuboramiz
        return new Promise((resolve, reject) => {
          pendingQueue.push({ resolve, reject, original });
        });
      }

      isRefreshing = true;
      try {
        await refreshTokens();

        // Navbatdagilarga yangilangan header bilan qayta urinish
        pendingQueue.forEach(({ resolve, original: cfg }) => {
          const at = getAccessToken();
          if (at) {
            cfg.headers = cfg.headers || {};
            cfg.headers.Authorization = `Bearer ${at}`;
          } else {
            delete cfg.headers?.Authorization;
          }
          resolve(api(cfg));
        });
        pendingQueue = [];

        // Hozirgini ham qayta yuboramiz
        const at = getAccessToken();
        if (at) {
          original.headers = original.headers || {};
          original.headers.Authorization = `Bearer ${at}`;
        } else {
          delete original.headers?.Authorization;
        }
        return api(original);
      } catch (e) {
        // Refresh ham yiqildi — tokenlarni tozalaymiz
        pendingQueue.forEach(({ reject }) => reject(e));
        pendingQueue = [];
        clearTokens();
        // Bu yerda login sahifaga yo'naltirishni xohlasa:
        window.location.href = "/login";
        return Promise.reject(e);
      } finally {
        isRefreshing = false;
      }
    }

    // Boshqa xatolarni o'z holicha qaytaramiz
    return Promise.reject(error);
  }
);

export default api;
export const BASE_URL = API_BASE_URL;
export const MEDIA_BASE_URL = API_BASE_URL.replace(/\/apis$/, '');
